import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { parseISO, format } from 'date-fns';
import * as Yup from 'yup';

import api from '../../../../services/api';
import history from '../../../../services/history';

import { AppError } from '../../../../errors/AppError';

import TitleBar from '../../../../components/TitleBar';
import { FormWrapper, Form } from '../../../../components/Form';
import Input from '../../../../components/Form/Input';

/** validação dos campos */
const schema = Yup.object().shape({
  descricao: Yup.string().required('O campo "Descrição" deve ser preenchido'),
});

function EmpresaLocalEditar() {
  const formRef = useRef(null);

  const location = useLocation();
  const { idEmpresa, id } = location.state;

  const [local, setLocal] = useState([]);

  useEffect(() => {
    api
      .get(`empresa/${idEmpresa}/local/${id}`)
      .then(({ data: { dataDesa, ...response } }) => {
        setLocal({
          ...response,
          dataDesa:
            dataDesa && format(parseISO(dataDesa), 'dd/MM/yyyy hh:mm:ss'),
        });
      });
  }, [idEmpresa, id]);

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          abortEarly: false,
        });

        const { descricao } = data;

        await api.put(`empresa/${idEmpresa}/local/${id}`, {
          descricao,
        });

        toast.success('Local atualizado com sucesso!');

        history.goBack();
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [idEmpresa, id]
  );

  return (
    <>
      <TitleBar back={!!location.background} title="Alterar Local" />
      <FormWrapper>
        <Form
          id="formEmpresaLocal"
          ref={formRef}
          schema={schema}
          initialData={local}
          onSubmit={handleConfirmar}
          autoComplete="off"
        >
          <Form.Column>
            <Form.Row>
              <Input
                id="codiLoca"
                name="codiLoca"
                label="Código"
                width={300}
                disabled
              />
              <Input
                id="dataDesa"
                name="dataDesa"
                label="Desativação"
                width={400}
                disabled
              />
            </Form.Row>
            <Form.Row>
              <Input
                id="descricao"
                name="descricao"
                label="Descrição"
                width={800}
              />
            </Form.Row>
          </Form.Column>
          <Form.Separate withFlex />
          <Form.Footer>
            <button
              id="btn-cancel"
              type="button"
              onClick={() => history.goBack()}
            >
              Cancelar
            </button>
            <button id="btn-submit" type="submit" form="formEmpresaLocal">
              Confirmar
            </button>
          </Form.Footer>
        </Form>
      </FormWrapper>
    </>
  );
}

export { EmpresaLocalEditar };
